import React, { useState } from "react";
import { MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useModal } from "../context/ModalContext";

const apiUrl = process.env.REACT_APP_API_URL;

export default function ChatButton({ postId, sellerId }) {
  const { showAlert } = useModal();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChat = async () => {
    console.log("Initiating chat for Post:", postId, "Seller:", sellerId);
    const userStr = localStorage.getItem("user") || sessionStorage.getItem("user");
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    if (!userStr || !token || token === "null" || token === "undefined") {
      navigate("/login");
      return;
    }

    if (!postId || !sellerId) {
      console.error("Missing IDs:", { postId, sellerId });
      showAlert("Error: Missing product or seller information.", "error");
      return;
    }

    const user = JSON.parse(userStr);
    
    // Use loose equality or cast to handle string vs number comparison
    if (Number(user.id) === Number(sellerId)) {
      showAlert("You cannot chat with yourself about your own post.", "warning");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${apiUrl}/api/conversations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ postId, sellerId }),
      });

      const data = await res.json();
      if (res.ok) {
        navigate(`/messages?chat=${data.conversationId}`);
      } else {
        showAlert(data.error || "Failed to start conversation", "error");
      }
    } catch (err) {
      console.error(err);
      showAlert("Error starting chat", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleChat}
      disabled={loading}
      className="flex-1 flex items-center justify-center gap-2 bg-white border-2 border-gray-900 text-gray-900 font-bold py-4 px-6 rounded-2xl hover:bg-gray-50 transition-all disabled:opacity-50"
    >
      <MessageCircle className="w-5 h-5" />
      {loading ? "Starting Chat..." : "Chat with Seller"}
    </button>
  );
}
